module.exports = __webpack_public_path__ + "static/media/galerija_2023 (23).5ff90724.png";